import { Icon, InlineChildren } from '@doordash/design-language';
import * as React from 'react';
import { Slider } from './styles';
var SliderContainer = function (_a) {
    var onChange = _a.onChange, value = _a.value, min = _a.min, max = _a.max, decrementZoom = _a.decrementZoom, incrementZoom = _a.incrementZoom, step = _a.step, isSubtractDisabled = _a.isSubtractDisabled, isAddDisabled = _a.isAddDisabled;
    var changeCallback = function (event) {
        var zoomVal = parseFloat(event.target.value);
        onChange(zoomVal);
    };
    return (React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexEnd, size: InlineChildren.Sizes.XSmall, alignItems: "center" },
        React.createElement(Icon, { size: Icon.Sizes.Large, type: Icon.Types.SubtractCircleLine, onClick: decrementZoom, accessibilityLabel: "decrement-label", color: isSubtractDisabled
                ? Icon.Colors.SystemGrey30
                : Icon.Colors.SystemBlack }),
        React.createElement(Slider, { "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value, min: min, max: max, type: "range", value: value, onChange: changeCallback, step: step }),
        React.createElement(Icon, { size: Icon.Sizes.Large, type: Icon.Types.AddCircleLine, onClick: incrementZoom, accessibilityLabel: "increment-label", color: isAddDisabled ? Icon.Colors.SystemGrey30 : Icon.Colors.SystemBlack })));
};
export default SliderContainer;
